// Helpers for government-scheme portfolio assets (asset_type
// "govt_schemes" with govt_holdings of {scheme, label, invested_inr,
// current_inr}). No market feed — both figures are user-entered.

export const GOVT_SCHEMES = [
  { value: "NPS", label: "NPS" },
  { value: "PPF", label: "PPF" },
  { value: "EPF", label: "EPF" },
  { value: "SSY", label: "SSY" },
  { value: "OTHER", label: "Other" },
];

export function govtSchemeLabel(h) {
  if (h.scheme === "OTHER") return h.label || "Other";
  return h.scheme;
}

/** "NPS + PPF · invested ₹1,54,621" one-line summary. */
export function govtSummary(asset) {
  const holdings = asset?.govt_holdings || [];
  const names = holdings.map(govtSchemeLabel).join(" + ");
  const invested = holdings.reduce((s, h) => s + (Number(h.invested_inr) > 0 ? Number(h.invested_inr) : 0), 0);
  if (!invested) return names;
  return `${names} · invested ₹${Math.round(invested).toLocaleString("en-IN")}`;
}

/**
 * Aggregate % gain vs. invested. Only holdings with an invested amount
 * count; returns null when none qualify.
 */
export function govtGainPercent(asset) {
  let invested = 0;
  let current = 0;
  for (const h of asset?.govt_holdings || []) {
    const inv = Number(h.invested_inr);
    const cur = Number(h.current_inr);
    if (!(inv > 0) || !(cur > 0)) continue;
    invested += inv;
    current += cur;
  }
  if (!invested) return null;
  return ((current - invested) / invested) * 100;
}
